import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru';

import VeeConfig from '../config/validate';

Validator.localize('ru', ru);
Vue.use(VeeValidate, VeeConfig);



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js